var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"transition-colors duration-500 ease-in-out bg-primary text-white px-4 py-2 font-bold",attrs:{"href":_vm.href,"download":"download"}},[_vm._v(_vm._s(_vm.label))])}
var staticRenderFns = []

export { render, staticRenderFns }